import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { isObject } from "@/shared/utils/typeGuards";

export const kInpaintingRoute = "/inpainting";

export interface InpaintingRequestBody {
    fileKey: string;
    bpm: number;
    complexity?: number;
    inpaintMaskStartSeconds?: number;
    inpaintMaskEndSeconds?: number;
    seed?: number;
    secondsEnd?: number;
}

export const isInpaintingRequestBody = (value: unknown): value is InpaintingRequestBody =>
    isObject(value) && typeof value.fileKey === "string" && typeof value.bpm === "number";

export const kInpaintingEndpoint: ApiEndpoint<InpaintingRequestBody, DownloadUrlResponse> = {
    route: kInpaintingRoute,
    label: "Inpainting",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v3.5 fill",
    description:
        "Regenerates a masked time range of an audio loop while preserving the surrounding audio, using the SpliceGen v3.5 fill model.",
    isRequestBody: isInpaintingRequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
